import actionBuilder, { create, update } from 'store/v2/actions';
import actionType, { bulkActionType, apiPath } from './constants';

const bulkRemind = (payload, silent = false) => {
  const message = 'Any tasks with assigned users have been sent a reminder email.';
  return create(actionType, `${apiPath}/bulk/remind`, { ...payload, silent, message });
};

const bulkUpdateWeights = (payload, silent = false) => {
  const message = 'Task weights updated successfully.';
  return update(
    actionType,
    `${apiPath}/bulk/weights`,
    { data: payload, silent, message },
    false,
    true
  );
};

const actions = {
  ...actionBuilder({ apiPath, bulkActionType, actionType }),
  bulkRemind,
  bulkUpdateWeights,
};

export default actions;
